import { render, staticRenderFns } from "./sopTemplateForm.vue?vue&type=template&id=a2fa3474&scoped=true&"
import script from "./sopTemplateForm.vue?vue&type=script&lang=js&"
export * from "./sopTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./sopTemplateForm.vue?vue&type=style&index=0&id=a2fa3474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fa3474",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2fa3474')) {
      api.createRecord('a2fa3474', component.options)
    } else {
      api.reload('a2fa3474', component.options)
    }
    module.hot.accept("./sopTemplateForm.vue?vue&type=template&id=a2fa3474&scoped=true&", function () {
      api.rerender('a2fa3474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/sopTemplate/sopTemplateForm.vue"
export default component.exports